module.exports = __webpack_public_path__ + "static/media/ssp.a7c9bd14.svg";